import React from 'react'

import { Route } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import SidebarLayout from '../layouts/SidebarLayout'
import FooterLayout from '../layouts/FooterLayout'
import PublicLayout from '../layouts/PublicLayout'
import SimpleLayout from '../layouts/SimpleLayout'

export const SidebarLayoutRoute = ({
  component: Component,
  nav,
  sidebarRight,
  title = 'Foodsby',
  overrideAuthRedirect,
  noScroll = false,
  showSubNav,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      noScroll={noScroll}
      render={matchProps => (
        <SidebarLayout
          nav={nav}
          overrideAuthRedirect={overrideAuthRedirect}
          showSubNav={showSubNav}
          sidebarRight={sidebarRight}
          {...matchProps}
        >
          <DocumentTitle
            title={`${title} | Foodsby – Lunch delivery solved for office professionals`}
          >
            <Component {...matchProps} />
          </DocumentTitle>
        </SidebarLayout>
      )}
    />
  )
}

export const FooterLayoutRoute = ({
  component: Component,
  title = 'Foodsby',
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <FooterLayout>
          <DocumentTitle
            title={`${title} | Foodsby – Lunch delivery solved for office professionals`}
          >
            <Component {...matchProps} />
          </DocumentTitle>
        </FooterLayout>
      )}
    />
  )
}

export const PublicLayoutRoute = ({
  component: Component,
  title = 'Foodsby',
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <PublicLayout>
          <DocumentTitle
            title={`${title} | Foodsby – Lunch delivery solved for office professionals`}
          >
            <Component {...matchProps} />
          </DocumentTitle>
        </PublicLayout>
      )}
    />
  )
}

export const SimpleLayoutRoute = ({
  component: Component,
  title = 'Foodsby',
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <SimpleLayout>
          <DocumentTitle
            title={`${title} | Foodsby – Lunch delivery solved for office professionals`}
          >
            <Component {...matchProps} />
          </DocumentTitle>
        </SimpleLayout>
      )}
    />
  )
}
